<template>
  <div class="add-object-jobs-work">
    <el-dialog :visible.sync="openObject">
      <div class="object-name"><span>Добавить объект</span>
        <div v-if="!this.parent">
          <i class="fa fa-edit" @click="openObjectJobsWork = true"></i>
        </div>
        <div v-else>
          <span style="font-size: 22px; margin-left: 12px; font-weight: bold;" @click="add">+</span>
          <span style="font-size: 22px; margin-left: 12px; font-weight: bold; color: #cc3700" @click="remove">–</span>
        </div>
      </div>

      <el-input class="input-obj" v-model="input" placeholder="Название объекта"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">Закрыть</el-button>
          <el-button type="primary" @click="saveDialog">Сохранить</el-button>
      </span>
    </el-dialog>


    <el-dialog title="Выбрать объекты и работы" :visible.sync="openObjectJobsWork" v-if="openObjectJobsWork">
      <div class="object-job-controls">
        <date-picker
          lang="ru"
          :editable="false"
          ref="datePicker"
          v-model="dateRange"
          placeholder="Фильтр по дате"
          range
        ></date-picker>

        <el-checkbox class="check" v-model="allPlan">Весь план</el-checkbox>
        <el-checkbox class="check" v-model="onlyPlan">Только работы с планом</el-checkbox>
        <template v-if="role === 'admin'">
        <span class="plan-name">
            Выбрать по компаниям
          </span>
          <filter-select hide-label multiple @blur="changePermission" v-model="selectCompanies" style="max-width: 340px"
                         :options="companies" label="Выбрать по компаниям"></filter-select>
        </template>
      </div>
      <div style="margin-top: 8px">
        <permission-jobs-work-object
          :select-companies="selectCompanies"
          :dates="dateRange"
          :allPlan="allPlan"
          :onlyPlan="onlyPlan"
          @update="addObjects"
          @remove="(e) => $emit('remove', e)"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import FilterSelect from "../../../../components/FilterSelect";
import PermissionObject from "../../Users/PermissionObject";
import PermissionJobsWorkObject from "./PermissionJobsWorkObject";
import {v4 as uuidv4} from 'uuid';
import {getCompaniesOptions} from "../../../../firestore/users";
import {getRole} from "../../../../firestore/permission";
import firebase from "firebase";
import {getUnits} from "../../../../firestore/units";
import {orderBy} from "lodash";

export default {
  name: "AddObjectJobsWork",
  components: {PermissionJobsWorkObject, PermissionObject, FilterSelect, DatePicker},
  data() {
    return {
      openObject: false,
      openObjectJobsWork: false,
      input: '',
      selectCompanies: [],
      dateRange: [],
      onlyPlan: false,
      parent: null,
      work_type_options: [],
      options_units: [],
      allPlan: false,
      objectsFirst: null,
      companies: [],
      role: 'worker'
    }
  },
  async mounted() {
    this.role = await getRole(this.$store.state.project.id);
    this.companies = await getCompaniesOptions(this.$store.state.project.id)

    if(this.role !== 'admin') {
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$store.state.company.uid || firebase.auth().currentUser.uid)
        .get()
        .then((data) => {
          data.forEach((user) => {
            this.selectCompanies = [this.companies.find(({label}) => label.toLowerCase() === user.data().company.toLowerCase())]
          })
        })
    }

    this.getWorkType('job')
    this.options_units = await getUnits(this.$store.state.project.id);

  },
  methods: {
    getWorkType(type) {
      console.log('GET_WORK_TYEP a')
      return new Promise(() => {
        const result = [];
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', '==', type).get().then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              data: data,
              value: subDoc.id,
              label: (data.name || data.id || '') + (data.stamp ? ' ' + data.stamp : ''),
            });
          });
          this.work_type_options = result;
        });
      });
    },
    changePermission() {
    },
    add() {
      this.isEdit = false
      this.input = ''
    },
    remove() {
      this.$emit('remove', this.parent)
      this.openObject = false
    },
    open(p = null, name = '') {
      this.openObject = true
      this.isEdit = !!name
      this.input = name;
      this.parent = p
      this.onlyPlan = false
      this.objectsFirst = p
      if (p) {
        this.parent = p
      }
    },
    closeDialog() {
      this.openObjectJobsWork = false
      this.openObject = false
      this.input = ''
    },
    saveDialog() {
      let name = this.input;
      if (this.parent && this.parent.name && !this.isEdit) {
        name = this.parent.name + ' > ' + name
      } else if (this.objectsFirst && this.objectsFirst.name) {
        const segment = this.removeLastSegment(this.objectsFirst.name);
        if (segment) {
          name = segment + ' > ' + name
        }
      }

      this.$emit('update', [{
        id: this.isEdit ? (this.parent && this.parent.id) : uuidv4(),
        index: null,
        name,
        parentId: (this.parent && this.parent.id) || null,
        jobs: [],
      }])
      this.closeDialog()
    },
    removeLastSegment(str) {
      const segments = str.split(' > ');
      segments.pop();
      return segments.join(' > ');
    },
    addObjects(objects) {
      objects.forEach((obj, key) => {
        if(obj.jobs) {
          obj.jobs.forEach((job, k) => {
            if(job && job.unit && !job.unit.value) {
              objects[key].jobs[k].unit = this.options_units.find(({value}) => value === job.unit_id)
            }
            if(job && job.work_type && !job.work_type.value) {
              objects[key].jobs[k].work_type = this.work_type_options.find(({value}) => value === job.work_type)
            }
          })
        }
        objects[key].jobs = orderBy(objects[key].jobs, 'index', 'asc')
      })

      let objUpdate = []
      if (this.objectsFirst) {
        objUpdate = objects.map((obj) => {
          return {
            ...obj,
            name: this.objectsFirst.name + ' > ' + obj.name,
            parentId: obj.parentId
          }
        })
      }

      this.$emit('update', this.objectsFirst ? objUpdate.map((obj) => {
        obj.isMain = true
        if (!obj.name) {
          obj.name = ''
        }

        return obj
      }) : objects.map((obj) => {
        if (!obj.name) {
          obj.name = ''
        }

        return obj
      }))
      this.openObjectJobsWork = false
      this.openObject = false
    }
  }
}
</script>

<style scoped lang="scss">
.add-object-jobs-work {
  .object-job-controls {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }


  .object-name {
    margin-top: -40px;
    position: relative;
    margin-right: 100px;
    align-items: center;
    color: #000000;
    display: flex;
    cursor: pointer;

    i {
      margin-left: 8px;
    }
  }

  .input-obj {
    margin-top: 28px;
  }

  .plan-name {
    text-align: left;
    margin-top: 10px;
    font-weight: bold;
    margin-bottom: 4px;
    color: #000;
  }

  .check {
    margin-top: 8px;
  }
}
</style>
<style lang="scss">
.add-object-jobs-work {
  .el-dialog__body {
    padding-bottom: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/AddObjectJobsWork.vue